import { TableCell, TableHead, TableRow, Typography, useTheme } from '@mui/material'

export default function ReassignExamTaskTableHeader() {
  const theme = useTheme()
  return (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
            bgcolor: 'secondary.light',
          }}
        >
          <Typography color="text.secondary" variant="subtitle2">
            Task details
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
            bgcolor: 'secondary.light',
          }}
        >
          <Typography color="text.secondary" variant="subtitle2">
            From status
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
            bgcolor: 'secondary.light',
          }}
        />
        <TableCell
          sx={{
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
            bgcolor: 'secondary.light',
          }}
        >
          <Typography color="text.secondary" variant="subtitle2">
            To status
          </Typography>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}
